import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import PagedList from "core/application/commons/pagedList";
import {queryRequest} from "../../../common/RequestUtils";
import {formatDateTimeReadable} from "../../../common/dateFormatters";
import TableEditButton from "../../../common/components/tables/TableEditButton";
import {CONFIGURATION_PATH} from "../ConfigurationWrapper";
import {MANAGE_INDUSTRY} from "../industries/ManageIndustry";
import TableDeleteButton from "../../../common/components/tables/TableDeleteButton";
import getNewsEdition, {NewsEditionDto} from "core/application/newsEditions/getNewsEdition";
import deleteNewsEdition from "core/application/newsEditions/deleteNewsEdition";
import Card from "../../../common/components/dataDisplay/Card";
import {Col, notification, Row} from "antd";
import Button from "../../../common/components/general/Button";
import Table from "common/components/dataDisplay/Table";
import {INDUSTRY_PATH} from "../industries/Industry";
import {MANAGE_NEWS_EDITION} from "./ManageNewsEdition";
import InputSearch, {SearchValues} from "../../common/InputSearch";
import {SearchFilter} from "core/domain/common/searchFilter";

export const NEWS_EDITION_PATH = "news-edition"

const NewsEdition : React.FC = () => {

    let history = useHistory();
    const {t: translate} = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [item, setItems] = useState<PagedList<NewsEditionDto>>({} as PagedList<NewsEditionDto>);
    const [searchFilter, setSearchFilter] = useState<SearchFilter>({
        pageNumber: 1,
        pageSize: 20,
        orderColumn: "createdAt",
        orderDescending: true
    });
    const searchInitialValues = {inputSearch: searchFilter.searchValue} as SearchValues;

    useEffect(() => {
        (async () => {
            await updateTableDate();
        })();
    }, [searchFilter])

    const updateTableDate = async () => {
        setLoading(true);
        setItems(await queryRequest(() => getNewsEdition(searchFilter)))
        setLoading(false);
    }
    const getColumns = (): any[] => {
        const columns = [
            {
                title: translate("general.name"),
                dataIndex: "operatorName",
                key: "operatorName",
                width: "30%",
                sorter: true,
                sortDirections: ["descend", "ascend"],
                render: (text: string, record: any) => (
                    <div>
                        <span>{record.operatorName}</span>
                    </div>
                )
            },
            {
                title: translate("general.time"),
                dataIndex: "time",
                key: "time",
                width: "20%",
                sorter: true,
                sortDirections: ["descend", "ascend"],
                render: (text: string, record: any) => (
                    <div>
                        <span>{record.time}</span>
                    </div>
                )
            },
            {
                title: translate("dashboard.created_at"),
                dataIndex: "createdAt",
                key: "createdAt",
                responsive: ["md"],
                sorter: true,
                sortDirections: ["descend", "ascend"],
                render: (text: string, record: any) => formatDateTimeReadable(record.createdAt)
            },
            {
                title: translate("dashboard.created_by"),
                dataIndex: "createdBy",
                key: "createdBy",
                responsive: ["md"],
                sorter: false,
                sortDirections: ["descend", "ascend"],
                render: (text: string, record: any) => (<span>{record.createdBy}</span>)
            },
            {
                title: translate("dashboard.action"),
                width: "10%",
                dataIndex: "",
                key: "actions",
                align: "center",
                sorter: false,
                render: (text: string, record: any) => (
                    <span>
                        <div className="actions flex flex__center">
                            <TableEditButton
                                className="mr-16"
                                editUrl={`/${CONFIGURATION_PATH}/${NEWS_EDITION_PATH}/${MANAGE_NEWS_EDITION}/${record.id}`}
                            />
                          <TableDeleteButton
                              disableDeleted={record.children?.length > 0}
                              onDelete={() => deleteNewsEdition(record.id)}
                              onDeleted={() => updateTableDate()}
                          />
                        </div>
                    </span>
                )
            }
        ];
        const columnToSort: any = columns.find(c => c.dataIndex === searchFilter.orderColumn);
        columnToSort.sortOrder = searchFilter.orderDescending ? "descend" : "ascend";
        return columns;
    };
    const onTableChange = (pagination: any, filters: any, sorter: any) => {
        setSearchFilter({
            ...searchFilter,
            pageNumber: pagination.current,
            pageSize: pagination.pageSize,
            orderColumn: sorter.field || "createdAt",
            orderDescending: sorter.order !== "ascend"
        });
    };
    const onSearch =  (search : any) => {
        if (search.inputSearch && search.inputSearch?.length < 2) {
            notification.open({type: "error", message: translate("general.search_length")});
        } else {
            setSearchFilter({
                ...searchFilter,
                searchValue: search.inputSearch,
            });
        }
    }
    return (
        <Card title={
            <Row>
                <Col xs={12} md={10}>
                    <h4>{translate("dashboard.newsEdition.name")}</h4>
                </Col>
                <Col xs={12} md={11}>
                    <InputSearch
                        placeholder={"Emri"}
                        initialValues={searchInitialValues}
                        onSearch={onSearch}
                        translate={translate}
                        loading={loading}
                    />
                </Col>
                <Col xs={12} md={3}>
                    <div className={"text-right"}>
                        <Button
                            icon="far fa-plus"
                            type="primary"
                            onClick={() => {
                                history.push(
                                    `${history.location.pathname}/${MANAGE_NEWS_EDITION}`
                                );
                            }}>
                            {translate("dashboard.add")}
                        </Button>
                    </div>
                </Col>
            </Row>
        }>
            <Row>
                <Col span={24}>
                    <Table
                        dataSource={item.items || []}
                        onChange={onTableChange}
                        columns={getColumns()}
                        loading={loading}
                        pagination={{
                            total: item.totalItemCount,
                            pageSize: item.pageSize,
                            current: item.pageNumber,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "30", "40"]
                        }}
                    />
                </Col>
            </Row>

        </Card>
    )
}

export default NewsEdition;